import JustEatLogo from 'src/assets/images/justeat-logo.svg';
import UberEatsLogo from 'src/assets/images/ubereats-logo.png';
import YextLogo from 'src/assets/images/yext-logo.png';
import deliverooLogo from 'src/assets/images/deliveroo-logo.png';
import OracleLogo from 'src/assets/images/oracle-logo.png';

export const channelsLogoHandler = (name: string): string => {
  switch (name) {
    case 'Uber Eats':
      return UberEatsLogo;
    case 'Just Eat':
      return JustEatLogo;
    case 'Deliveroo':
      return deliverooLogo;
    case 'Yext':
      return YextLogo;
    case 'Oracle':
      return OracleLogo;
  }
};
